export enum StatementType {
    All = null,
    Cash = 1,  
    partiallyCovered = 2,
    FullyCovered = 3,
}